exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Cookie--afterlife {\n  background: #343a40;\n  color: #fff;\n  padding: 1.250em;\n  white-space: pre-line;\n}\n.Cookie--afterlife .Cookie__button {\n  background: #007bff;\n  padding: 0.625em 3.125em;\n  color: #fff;\n  border-radius: 0;\n}\n.Cookie--afterlife div.Cookie__button:hover {\n  background: #0069d9;\n}\n.Cookie--afterlife .Cookie__content {\n  margin-left: 10%;\n  margin-right: 10%;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c510318","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/CookiePopup.vue
// module id = CJCD
// module chunks = 1